module.exports = __webpack_public_path__ + "img/activate-banner-background-4.cdf3c09.png";